import { render, staticRenderFns } from "./report-face15.vue?vue&type=template&id=6f9893ea&scoped=true"
import script from "./report-face15.vue?vue&type=script&lang=ts"
export * from "./report-face15.vue?vue&type=script&lang=ts"
import style0 from "./report-face15.vue?vue&type=style&index=0&id=6f9893ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9893ea",
  null
  
)

export default component.exports